import { startOfYear, subDays, subHours, subMonths } from 'date-fns'
import { find } from 'lodash'

import messages from './messages'

class ViewByFilterMap {
  VIEW_BY_TYPES = {
    RELATIVE: 'relative',
    CUSTOM_DATE: 'custom_date',
    USER_ATTRIBUTE: 'user_attribute'
  }

  VIEW_BY_FILTER_MAP = [
    {
      key: '1hour',
      value: '1-hour',
      interval: '1m',
      type: this.VIEW_BY_TYPES.RELATIVE,
      oldest: () => subHours(new Date(), 1).toISOString(),
      chartFormat: 'hh:mma', // Output: 11:36
      difference: true,
      labelId: messages.pastOneHourSelectOption
    },
    {
      key: '1day',
      value: '1-day',
      interval: '1h',
      type: this.VIEW_BY_TYPES.RELATIVE,
      oldest: () => subHours(new Date(), 24).toISOString(),
      chartFormat: 'M/DD - ha', // Output: 1/27 - 1am
      difference: true,
      labelId: messages.pastTwentyFourHoursSelectOption
    },
    {
      key: '7days',
      value: '7-days',
      interval: '12h',
      type: this.VIEW_BY_TYPES.RELATIVE,
      oldest: () => subDays(new Date(), 7).toISOString(),
      chartFormat: 'ddd Do - ha', // Output: Mon 27th - 1am
      difference: true,
      labelId: messages.pastSevenDaysSelectOption
    },
    {
      key: '30days',
      value: '30-days',
      interval: '1d',
      type: this.VIEW_BY_TYPES.RELATIVE,
      oldest: () => subDays(new Date(), 30).toISOString(),
      chartFormat: 'MMM Do', // Output: 1/27 M/D
      difference: true,
      labelId: messages.pastThirtyDaysSelectOption
    },
    {
      key: '90days',
      value: '90-days',
      interval: '1w',
      type: this.VIEW_BY_TYPES.RELATIVE,
      oldest: () => subDays(new Date(), 90).toISOString(),
      chartFormat: 'MMM Do YYYY',
      difference: true,
      labelId: messages.pastNinetyDaysSelectOption
    },
    {
      key: '12months',
      value: '12-months',
      interval: '1M',
      type: this.VIEW_BY_TYPES.RELATIVE,
      oldest: () => subMonths(new Date(), 12).toISOString(),
      chartFormat: 'MMMM YYYY',
      difference: true,
      labelId: messages.pastTwelveMonthsOption
    },
    {
      key: 'yearToDate',
      value: 'year-to-date',
      interval: '1M',
      type: this.VIEW_BY_TYPES.RELATIVE,
      oldest: () => startOfYear(new Date()).toISOString(),
      chartFormat: 'MMMM',
      difference: true,
      labelId: messages.yearToDateOption
    },
    {
      key: 'allTime',
      value: 'all-time',
      interval: '1M',
      type: this.VIEW_BY_TYPES.RELATIVE,
      oldest: () => '2019-07-13T12:00:00.000Z', // Just an arbitrary old date, TODO Maybe use the notification start?
      chartFormat: 'MMM YYYY',
      difference: true,
      labelId: messages.allTimeOption
    },
    {
      key: 'dateRange',
      value: 'date-range',
      type: this.VIEW_BY_TYPES.CUSTOM_DATE,
      labelId: messages.dateRangeSelectOption
    }
  ]

  getViewByRangeItem(viewByRange: any) {
    return find(this.VIEW_BY_FILTER_MAP, item => {
      return item.value === viewByRange
    })
  }

  getType(viewByRange: any) {
    // @ts-expect-error
    return find(this.VIEW_BY_FILTER_MAP, item => {
      return item.value === viewByRange
    }).type
  }
}

export default new ViewByFilterMap()
